<template>
    <div>
        <v-container style="max-width: 1500px !important">
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 1rem !important;">
                <v-system-bar class="py-5 px-3 system-bar-title" dark>
                    Anexos
                    <!-- <v-tooltip bottom color="success">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="green" v-bind="attrs" v-on="on" dark @click="exportExcel"
                                style="margin: 1rem 0;height: 1.9rem;">
                                <v-icon color="white"
                                    style="font-size: 1.5rem;color: white !important;">mdi-download-box</v-icon>
                            </v-btn>
                        </template>
                        <span>Descargar</span>
                    </v-tooltip> -->
                </v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5 elevation-1"
                style="margin-bottom: 2rem !important;padding: 2rem .6rem 0 .6rem;">
                <v-row>
                    <v-col cols="12" lg="3" md="4">
                        <v-text-field max-width="200" class="mx-3" v-model="searchAnexo" label="Anexo"
                            append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="mx-auto my-5" style=" margin:0 auto;padding: 1.5rem;">
                <div>
                    <v-data-table :headers="headers" :items="filteredData" :loading="isLoading" 
                        loading-text="Cargando... Por favor espere" style="">
                        <template v-slot:[`item.actions`]="{ item ,index }">
                            <v-tooltip bottom color="teal">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2 custom-btn" fab dark @click="exportExcel(index)"
                                        color="teal" v-bind="attrs" v-on="on">
                                        <v-icon class="custom-icon" dark>
                                            mdi mdi-arrow-down-bold-box
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Descargar</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </div>
                <v-dialog v-model="dialogEdit" v-if="dialogEdit" max-width="800px">
                    <formPaciente @editClose="editClose" :idItem="idItem"></formPaciente>
                </v-dialog>
                <!-- <button @click="exportToExcel">Formato 1</button>
                <button @click="exportToExcel2">Formato 2</button>
                <button @click="exportToExcel3">Formato 3</button>
                <button @click="exportToExcel4">Formato 4</button>
                <button @click="exportToExcel5">Formato 5</button>
                <button @click="exportToExcel6">Formato 6</button> -->
                <!--  <v-dialog v-model="dialogImport" v-if="dialogImport" max-width="700px">
                    <importPaciente @closeDialog="closeDialog" :date="date"></importPaciente>
                </v-dialog> -->
            </v-card>
            <v-dialog v-model="dialogLoader" persistent width="300"
                style="padding: 1rem;overflow: hidden !important;background: white !important;">
                <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
            </v-dialog>
        </v-container>
    </div>
</template>
<style scoped>
::v-deep .theme--dark.v-system-bar {
    color: hsl(0, 0%, 100%) !important;
}

.layout-loading {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 202;
    background: #e3e3e3b1;
}

::v-deep .v-dialog {
    display: flex;
    justify-content: center;
    box-shadow: none;
    overflow-y: hidden !important;
}

.system-bar-title {
    display: flex;
    justify-content: space-between;
    color: white;
    padding: 1.2rem 1.4rem !important;
}

::v-deep tr th {
    text-wrap: nowrap !important;
}

::v-deep .v-card {
    box-shadow: 0px 0px 11px 6px rgb(15 61 99 / 27%) !important;
}

::v-deep tr td {
    text-wrap: nowrap !important;
}

::v-deep .theme--dark.v-system-bar {
    background: #1780cd;
}

.custom-btn {
    width: 32px !important;
    height: 32px !important;
}

.custom-icon {
    font-size: 20px !important;
}

.bg-primary-table {
    font-weight: 400;
}

.text-start {
    font-size: 0.8rem !important;
}

.container {
    max-width: 3000px !important;
}

td {
    white-space: nowrap;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";

/* import importPaciente from "./import.vue";
import Histograma from "./histograma.vue"; */
export default {
    data() {
        return {
            salasItems: [
                { label: "Clínicas", value: "0" },
                { label: "S1 CNSR", value: "1" },
                { label: "S2 CNSR", value: "2" },
                { label: "S3 CNSR", value: "3" },
                { label: "S4 CNSR", value: "4" },
                { label: "S5 DP", value: "5" }
            ],
            searchSala: [],
            statusEdit: true,
            dialogHistograma: false,
            date: new Date().toISOString().slice(0, 7),
            modal: false,
            searchAnexo: null,
            searchDNI: null,
            searchAutogenerado: null,
            dialogImport: false,
            dialogLoader: false,
            ver: false,
            searchDocumento: "",
            searchNombre: "",
            dataPaciente: [
                {anexo:"ANEXO CNSR-20A"},
                {anexo:"ANEXO CNSR-20B"},
                {anexo:"ANEXO CNSR-20C"},
                {anexo:"ANEXO CNSR-20D"},
                {anexo:"ANEXO CNSR-21A"},
                {anexo:"ANEXO CNSR-21B"},
            ],
            dataEnvio: {
                fecha: null,
            },
            date1: new Date()
                .toISOString()
                .substr(0, 10),
            search: "",
            sortBy: [{ key: "cupos_disponible", order: "asc" }],
            headers: [
                { text: "ANEXO", value: "anexo", align: "center" },
                { text: "ACCIONES", value: "actions", align: "center" }
            ],
            dialogEdit: false,
            dialogDelete: false,
            isLoading: false,
            menu: false,
            idItem: null,
            selectedColumns: [
                'FECHA_RESULTADO', 'NUM_DOC', 'AUTOGENERADO', 'PACIENTE', 'SALA', 'ALBUMINA', 'CALCIO_TOTAL', 'CALCIO_POST', 'CALCIO_PRE', 'CALCIO_IONIZADO', 'CLORURO', 'COLESTEROL', 'CREATININA',
                'CREATININA_POST', 'CREATININA_PRE', 'FERRITINA', 'GLUCOSA', 'FIERRO', 'COLESTEROL_HDL', 'COLESTEROL_LDL', 'PARATOHORMONA', 'FOSFATASA_ALCALINA', 'FOSFORO', 'FOSFORO_POST', 'FOSFORO_PRE', 'POTASIO', 'SODIO', 'TRANSAMINASA_GLUTAMICO_PIRUVIC', 'TRANSAMINASA_GLUTAMICO_OXALACE', 'TRANSFERRINA', 'TRIGLICERIDOS', 'UREA', 'ACIDO_URICO', 'GLOBULOS_BLANCOS', 'GLOBULOS_ROJOS', 'HEMATOCRITO', 'HEMOGLOBINA', 'PROTEINA_C_REACTIVA', 'ANTIGENO_HEPATIT', 'ANTICUERPO_HEPATITIS_CORE', 'ANTICUERPO_HEPATITIS_C', 'UREA_PRE', 'UREA_POST', 'HCO3'
            ],
            itemMes: null,
            itemPeriodo: null,
            dataArray: []
        };
    },
    methods: {
        exportToExcel() {
            const XLSX = require("xlsx-js-style");
            // Crear una hoja de cálculo
            const workbook = XLSX.utils.book_new();
            const worksheet = {};

            // Definir el rango y las celdas
            const data = [
                ["ANEXO CNSR-20A"],
                [],
                ["LIMPIEZA Y DESINFECCIÓN DE MATERIAL, EQUIPOS, MOBILIARIO Y PISO DE SALA DE HEMODIÁLISIS"],
                [],
                ["", "MES/AÑO:", "", "DÍAS", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["TURNO", "RESPONSABLE", "ACTIVIDADES / FECHAS", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"],
                ["I TURNO", "Personal de Limpieza", "HORA DE INICIO", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "Coloca guantes de nitrilo, anuda y retira las bolsas de desecho, contenedor rígido para punzo cortantes.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "No comprime las bolsas.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "Realiza lavado de manos y cambio guantes.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "Realiza barrido húmedo para el recojo de papel y residuos sólidos.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "HORA FINAL", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Técnico en Enfermería", "HORA DE INICIO", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "Lavado de manos y calzado guantes.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "Limpieza de coches, tambores, pizetas.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "Lavado de manos y calzado guantes.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "Limpieza de mesa de mayo.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "Lavado de manos y calzado guantes.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "Limpieza de tensiómetro rodante.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "Lavado de manos y calzado guantes.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "Limpieza de sillón de diálisis.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "Lavado de manos y calzado guantes.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "Desecha guantes y lavado de manos.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "HORA FINAL", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Personal de Limpieza", "HORA DE INICIO", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "Aplica el desinfectante sobre el piso, iniciade la zona menos contaminada a l a más contaminada.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "", "HORA FINAL", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["FIRMA Y SELLO DE ENFERMERA RESPONSABLE", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
            ];

            // Rellenar la hoja de cálculo
            for (let r = 0; r < data.length; r++) {
                for (let c = 0; c < data[r].length; c++) {
                    const cell_ref = XLSX.utils.encode_cell({ r, c });
                    worksheet[cell_ref] = {
                        v: data[r][c],
                        s: {
                            font: { bold: r === 0 || r === 2, size: 9 },
                            alignment: { horizontal: "center", vertical: "center", wrapText: true, },
                            border: {
                                top: { style: "thin", color: { rgb: "000000" } },
                                bottom: { style: "thin", color: { rgb: "000000" } },
                                left: { style: "thin", color: { rgb: "000000" } },
                                right: { style: "thin", color: { rgb: "000000" } },
                            },
                            fill: r === 2 ? { patternType: "solid", fgColor: { rgb: "FFFF00" } } : undefined,
                        },
                    };
                }
            }

            // Configurar el rango de celdas
            worksheet["!ref"] = `A1:AE${data.length}`;

            // Combinar celdas para el título y encabezados
            worksheet["!merges"] = [
                { s: { r: 0, c: 0 }, e: { r: 0, c: 30 } }, // ANEXO
                { s: { r: 2, c: 0 }, e: { r: 2, c: 30 } }, // Título
                { s: { r: 4, c: 3 }, e: { r: 4, c: 30 } }, // Cabecera "DÍAS"
                { s: { r: 6, c: 0 }, e: { r: 26, c: 0 } }, // TURNO I
                { s: { r: 6, c: 1 }, e: { r: 11, c: 1 } }, // Personal
                { s: { r: 12, c: 1 }, e: { r: 23, c: 1 } }, // Personal
                { s: { r: 24, c: 1 }, e: { r: 26, c: 1 } }, // Personal
                { s: { r: 27, c: 0 }, e: { r: 27, c: 2 } }, // Personal
            ];
            // Definir anchos de columnas
            worksheet["!cols"] = [
                { wch: 7 }, // Columna A: TURNO
                { wch: 9 }, // Columna B: RESPONSABLE
                { wch: 16 }, // Columna C: ACTIVIDADES / FECHAS
                ...Array(30).fill({ wch: 2 }), // Resto de columnas (DÍAS) con ancho 5
            ];
            // Estilo para la celda combinada "TURNO I"
            worksheet["A5"].s = {
                alignment: {
                    vertical: "center", // Centrado vertical
                    horizontal: "center", // Centrado horizontal
                    textRotation: 90, // Texto en formato vertical (rotación 90 grados)
                },
                font: {
                    bold: true, // Texto en negrita
                },
            };

            //Aplicar color
            worksheet["B7"].s = {
                font: { bold: false, size: 9 },
                alignment: { horizontal: "center", vertical: "center", wrapText: true, },
                fill: { patternType: "solid", fgColor: { rgb: "ffca33 " } },
            };
            worksheet["B13"].s = {
                font: { bold: false, size: 9 },
                alignment: { horizontal: "center", vertical: "center", wrapText: true, },
                fill: { patternType: "solid", fgColor: { rgb: "03d144" } },
            };
            worksheet["B25"].s = {
                font: { bold: false, size: 9 },
                alignment: { horizontal: "center", vertical: "center", wrapText: true, },
                fill: { patternType: "solid", fgColor: { rgb: "ffca33" } },
            };
            worksheet["C7"].s = {
                font: { bold: false, size: 9 },
                alignment: { horizontal: "center", vertical: "center", wrapText: true, },
                fill: { patternType: "solid", fgColor: { rgb: "06b5df" } },
                border: {
                    top: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } },
                },
            };
            worksheet["C12"].s = {
                font: { bold: false, size: 9 },
                alignment: { horizontal: "center", vertical: "center", wrapText: true, },
                fill: { patternType: "solid", fgColor: { rgb: "06b5df" } },
                border: {
                    top: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } },
                },
            };
            worksheet["C13"].s = {
                font: { bold: false, size: 9 },
                alignment: { horizontal: "center", vertical: "center", wrapText: true, },
                fill: { patternType: "solid", fgColor: { rgb: "06b5df" } },
                border: {
                    top: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } },
                },
            };
            worksheet["C24"].s = {
                font: { bold: false, size: 9 },
                alignment: { horizontal: "center", vertical: "center", wrapText: true, },
                fill: { patternType: "solid", fgColor: { rgb: "06b5df" } },
                border: {
                    top: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } },
                },
            };
            worksheet["C25"].s = {
                font: { bold: false, size: 9 },
                alignment: { horizontal: "center", vertical: "center", wrapText: true, },
                fill: { patternType: "solid", fgColor: { rgb: "06b5df" } },
                border: {
                    top: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } },
                },
            };
            worksheet["C27"].s = {
                font: { bold: false, size: 9 },
                alignment: { horizontal: "center", vertical: "center", wrapText: true, },
                fill: { patternType: "solid", fgColor: { rgb: "06b5df" } },
                border: {
                    top: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } },
                },
            };
            worksheet["A28"].s = {
                font: { bold: false, size: 9 },
                alignment: { horizontal: "center", vertical: "center", wrapText: true, },
                fill: { patternType: "solid", fgColor: { rgb: "f7e002" } },
            };
            // Agregar la hoja al libro
            XLSX.utils.book_append_sheet(workbook, worksheet, "Limpieza");

            // Generar y descargar el archivo Excel
            const excelData = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
            const buffer = new ArrayBuffer(excelData.length);
            const view = new Uint8Array(buffer);
            for (let i = 0; i < excelData.length; i++) view[i] = excelData.charCodeAt(i) & 0xff;
            const blob = new Blob([buffer], { type: "application/octet-stream" });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "ANEXO_CNSR-20A.xlsx";
            link.click();
        },
        exportToExcel2() {
            const XLSX = require("xlsx-js-style");
            // Crear una hoja de cálculo
            const workbook = XLSX.utils.book_new();
            const worksheet = {};

            // Definir el rango y las celdas
            const data = [
                ["ANEXO CNSR-20B"],
                [],
                ["LIMPIEZA Y DESINFECCION DE MATERIAL, EQUIPOS Y MOBILIARIO POR AREAS REALIZADO POR TECNICO EN ENFERMERIA"],
                [],
                ["MES/AÑO:", "", "DÍAS", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["AMBIENTES", "LIMP. Y DESINFECC DE:", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"],
                ["SALA DE HEMODIALISIS", "Coche de paro", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Refrigeradora para muestras", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Frascos humidificadores.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Riñoneras", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Tablillas", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Férulas", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Tambores", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Pizetas", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Vitrinas", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Personal Responsable", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["SALA DE LAVADO DE MATERIAL", "Contenedores para el lavado de riñoneras, equipos de curación, tablillas.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Repisa o mesa.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Personal Responsable", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["SALA DE CEBADO", "Máquina (Desinfecc. Interna)", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Máquina (Desinfecc. Externa)", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Estantes, vitrinas.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Contenedores para el transporte de sistemas extracorpóreos cebados..", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Personal Responsable", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["CUARTO LIMPIO", "Contenedores, mesa, estante ylo vitrina.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Equipo de esterilización.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Refrigeradora para medicamentos", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Personal Responsable", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["LOCAL AISLADO", "Máquina, sillón, coche", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "Personal Responsable", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["AREA LIMPIΑ", "Mobiliario", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["FIRMA Y SELLO DE ENFERMERA RESPONSABLE", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
            ];

            // Rellenar la hoja de cálculo
            for (let r = 0; r < data.length; r++) {
                for (let c = 0; c < data[r].length; c++) {
                    const cell_ref = XLSX.utils.encode_cell({ r, c });
                    worksheet[cell_ref] = {
                        v: data[r][c],
                        s: {
                            font: { bold: r === 0 || r === 2, size: 9 },
                            alignment: { horizontal: "center", vertical: "center", wrapText: true, },
                            border: {
                                top: { style: "thin", color: { rgb: "000000" } },
                                bottom: { style: "thin", color: { rgb: "000000" } },
                                left: { style: "thin", color: { rgb: "000000" } },
                                right: { style: "thin", color: { rgb: "000000" } },
                            },
                            fill: r === 2 ? { patternType: "solid", fgColor: { rgb: "FFFF00" } } : undefined,
                        },
                    };
                }
            }

            // Configurar el rango de celdas
            worksheet["!ref"] = `A1:AE${data.length}`;

            // Combinar celdas para el título y encabezados
            worksheet["!merges"] = [
                { s: { r: 0, c: 0 }, e: { r: 0, c: 30 } }, // ANEXO
                { s: { r: 2, c: 0 }, e: { r: 2, c: 30 } }, // Título
                { s: { r: 4, c: 2 }, e: { r: 4, c: 30 } }, // Cabecera "DÍAS"
                { s: { r: 6, c: 0 }, e: { r: 14, c: 0 } }, // Personal
                { s: { r: 16, c: 0 }, e: { r: 17, c: 0 } }, // Personal
                { s: { r: 19, c: 0 }, e: { r: 22, c: 0 } }, // Personal
                { s: { r: 24, c: 0 }, e: { r: 26, c: 0 } }, // Personal
                { s: { r: 31, c: 0 }, e: { r: 31, c: 1 } }, // Personal
            ];
            // Definir anchos de columnas
            worksheet["!cols"] = [
                { wch: 7 }, // Columna A: TURNO
                { wch: 9 }, // Columna B: RESPONSABLE
                ...Array(30).fill({ wch: 2 }), // Resto de columnas (DÍAS) con ancho 5
            ];
            const arrrayColor=[{cell:"A7",color:"ffca33 "},{cell:"A16",color:"ffca33 "},{cell:"B16",color:"ffca33 "},{cell:"A17",color:"ffca33 "},{cell:"A19",color:"ffca33 "},{cell:"B19",color:"ffca33 "},{cell:"A2O",color:"ffca33 "},{cell:"A24",color:"ffca33 "},{cell:"B24",color:"ffca33 "},{cell:"A25",color:"ffca33 "},{cell:"A28",color:"ffca33 "},{cell:"B28",color:"ffca33 "},{cell:"A29",color:"ffca33 "},{cell:"B29",color:"ffca33 "},{cell:"A30",color:"ffca33 "},{cell:"B30",color:"ffca33 "},{cell:"A31",color:"ffca33 "},{cell:"B31",color:"ffca33 "},{cell:"A32",color:"f7e002 "}];

            for (let i = 0; i < arrrayColor.length; i++) {
                const element = arrrayColor[i];
                console.log("Procesando celda:", element);

                // Limpiar el color
                const cleanColor = element.color.trim();

                // Verificar si la celda existe, si no, inicializarla
                if (!worksheet[element.cell]) {
                    console.log("elemento que no se encuentra",element.cell)
                    worksheet[element.cell] = {}; // Inicializa la celda
                }

                // Aplicar el estilo
                worksheet[element.cell].s = {
                    font: { bold: false, size: 9 },
                    alignment: { horizontal: "center", vertical: "center", wrapText: true },
                    fill: { patternType: "solid", fgColor: { rgb: cleanColor } },
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } },
                    },
                };
            }
            // Agregar la hoja al libro
            XLSX.utils.book_append_sheet(workbook, worksheet, "Limpieza");

            // Generar y descargar el archivo Excel
            const excelData = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
            const buffer = new ArrayBuffer(excelData.length);
            const view = new Uint8Array(buffer);
            for (let i = 0; i < excelData.length; i++) view[i] = excelData.charCodeAt(i) & 0xff;
            const blob = new Blob([buffer], { type: "application/octet-stream" });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "ANEXO_CNSR-20B.xlsx";
            link.click();
        },
        exportToExcel3() {
            const XLSX = require("xlsx-js-style");
            // Crear una hoja de cálculo
            const workbook = XLSX.utils.book_new();
            const worksheet = {};

            // Definir el rango y las celdas
            const data = [
                ["ANEXO CNSR-20 C"],
                [],
                ["ACTIVIDADES DE LIMPIEZA Y DESINFECCION DE LA IPRESS (PERSONAL DE LIMPIEZA)"],
                [],
                ["","IPRESS", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["","MES/AÑO:", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "ACTIVIDADES PROGRAMADAS", "DIAS", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["NRO", "ACTIVIDAD", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"],
                ["", "DIARIAS (Limpieza rutina)", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["1", "Sala de espera/ consultorio/ sala de observación", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["2", "Sala de Hd: lavadero de manos", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["3", "Contenedores de residuos comunes y biocontaminados de sala de tratamiento y servicios higiénicos.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["4", "Servicios higiénicos de pacientes y personal.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["5", "Sala de Cebado y sala de lavado de mat. Biocontaminado", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["6", "Area Biocontaminada y Cuarto Biocontaminado", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["7", "Contenedores de almacenamiento de ropa biocontaminada", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["8", "Contenedores de residuos comunes , biocontaminados y especiales del cuarto biocontaminado", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["9", "Local aislado", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["10", "Cuarto Limpio/ Area limpia", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["11", "Sala de tratamiento de agua / sala de máquinas", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["12", "Almacén/ vestuarios y comedor", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["13", "Administración", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["14", "Escritorios, mesas, archivadores, sillas.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["15", "Cuarto de limpieza.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "SEMANAL: Limpieza profunda.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["16", "Ventanas/ Repisas.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["17", "Puertas, divisiones y paredes.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["18", "Servicios higiénicos.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["19", "Pisos, paredes y techos.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["20", "Vitrinas/ Carteles.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["21", "Jardines o áreas circundantes.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["", "MENSUAL: Limpieza profunda.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["22", "Vidrios por el exterior.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["23", "Techos externo e interno.", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["24", "Paredes y pisos de todo el establecimiento", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["25", "Lámparas y/o fluorescentes", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["26", "Inyectores y extractores", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["","FIRMA Y SELLO DE PERSONAL QUE VERIFICA", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
            ];

            // Rellenar la hoja de cálculo
            for (let r = 0; r < data.length; r++) {
                for (let c = 0; c < data[r].length; c++) {
                    const cell_ref = XLSX.utils.encode_cell({ r, c });
                    worksheet[cell_ref] = {
                        v: data[r][c],
                        s: {
                            font: { bold: r === 0 || r === 2, size: 9 },
                            alignment: { horizontal: "center", vertical: "center", wrapText: true, },
                            border: {
                                top: { style: "thin", color: { rgb: "000000" } },
                                bottom: { style: "thin", color: { rgb: "000000" } },
                                left: { style: "thin", color: { rgb: "000000" } },
                                right: { style: "thin", color: { rgb: "000000" } },
                            },
                            fill: r === 2 ? { patternType: "solid", fgColor: { rgb: "FFFF00" } } : undefined,
                        },
                    };
                }
            }

            // Configurar el rango de celdas
            worksheet["!ref"] = `A1:AE${data.length}`;

            // Combinar celdas para el título y encabezados
            worksheet["!merges"] = [
                { s: { r: 0, c: 0 }, e: { r: 0, c: 30 } }, // ANEXO
                { s: { r: 2, c: 0 }, e: { r: 2, c: 30 } }, // Título
                { s: { r: 4, c: 2 }, e: { r: 4, c: 30 } }, // Cabecera "DÍAS"
            ];
            // Definir anchos de columnas
            worksheet["!cols"] = [
                { wch: 4 }, // Columna A: TURNO
                { wch: 15 }, // Columna B: RESPONSABLE
                ...Array(30).fill({ wch: 2 }), // Resto de columnas (DÍAS) con ancho 5
            ];
            /* const arrrayColor=[{cell:"A7",color:"ffca33 "},{cell:"A16",color:"ffca33 "},{cell:"B16",color:"ffca33 "},{cell:"A17",color:"ffca33 "},{cell:"A19",color:"ffca33 "},{cell:"B19",color:"ffca33 "},{cell:"A2O",color:"ffca33 "},{cell:"A24",color:"ffca33 "},{cell:"B24",color:"ffca33 "},{cell:"A25",color:"ffca33 "},{cell:"A28",color:"ffca33 "},{cell:"B28",color:"ffca33 "},{cell:"A29",color:"ffca33 "},{cell:"B29",color:"ffca33 "},{cell:"A30",color:"ffca33 "},{cell:"B30",color:"ffca33 "},{cell:"A31",color:"ffca33 "},{cell:"B31",color:"ffca33 "},{cell:"A32",color:"f7e002 "}];

            for (let i = 0; i < arrrayColor.length; i++) {
                const element = arrrayColor[i];
                console.log("Procesando celda:", element);

                // Limpiar el color
                const cleanColor = element.color.trim();

                // Verificar si la celda existe, si no, inicializarla
                if (!worksheet[element.cell]) {
                    console.log("elemento que no se encuentra",element.cell)
                    worksheet[element.cell] = {}; // Inicializa la celda
                }

                // Aplicar el estilo
                worksheet[element.cell].s = {
                    font: { bold: false, size: 9 },
                    alignment: { horizontal: "center", vertical: "center", wrapText: true },
                    fill: { patternType: "solid", fgColor: { rgb: cleanColor } },
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } },
                    },
                };
            } */
            // Agregar la hoja al libro
            XLSX.utils.book_append_sheet(workbook, worksheet, "Limpieza");

            // Generar y descargar el archivo Excel
            const excelData = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
            const buffer = new ArrayBuffer(excelData.length);
            const view = new Uint8Array(buffer);
            for (let i = 0; i < excelData.length; i++) view[i] = excelData.charCodeAt(i) & 0xff;
            const blob = new Blob([buffer], { type: "application/octet-stream" });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "ANEXO_CNSR-20C.xlsx";
            link.click();
        },
        exportToExcel4() {
            const XLSX = require("xlsx-js-style");
            // Crear una hoja de cálculo
            const workbook = XLSX.utils.book_new();
            const worksheet = {};

            // Definir el rango y las celdas
            const data = [
                ["ANEXO CNSR-20 D"],
                [],
                ["REGISTRO DE UTILIZACIÓN DE INSUMOS DE LIMPIEZA"],
                [],
                ["REGISTRO DE UTILIZACIÓN DE INSUMOS DE LIMPIEZA ( PERSONAL DE LIMPIEZA)"],
                [],
                ["","IPRESS", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["","MES/AÑO:", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                [],
                ["","", "DIAS", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["INSUMOS","UNIDAD DE MEDIDA", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"],
                ["GUANTES DE NITRILO", "PAR", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["GUANTES DE GOMA", "PAR", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["GUANTES DE PVC ", "PAR", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["DETERGENTE", "GRAMOS", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["HIPOCLORITO 1%", "LITROS", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["AMONIO CUATERNARIO", "LITROS", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["PINO", "LITROS", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["TRAPEADORES", "UNIDAD", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["PAÑOS", "UNIDAD", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["BOLSAS ROJAS 50LITROS ", "UNIDAD", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["BOLSAS NEGRAS DE 50 LITROS", "UNIDAD", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["BOLSAS AMARILLAS DE 50 LITROS", "UNIDAD", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["BOLSAS ROJAS DE 170 LITROS", "UNIDAD", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["BOLSAS NEGRAS DE 170 LITROS", "UNIDAD", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["BOLSAS AMARILLAS DE 170 LITROS", "UNIDAD", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                ["FIRMA Y SELLO DE PERSONAL QUE VERIFICA", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
            ];

            // Rellenar la hoja de cálculo
            for (let r = 0; r < data.length; r++) {
                for (let c = 0; c < data[r].length; c++) {
                    const cell_ref = XLSX.utils.encode_cell({ r, c });
                    worksheet[cell_ref] = {
                        v: data[r][c],
                        s: {
                            font: { bold: r === 0 || r === 2, size: 9 },
                            alignment: { horizontal: "center", vertical: "center", wrapText: true, },
                            border: {
                                top: { style: "thin", color: { rgb: "000000" } },
                                bottom: { style: "thin", color: { rgb: "000000" } },
                                left: { style: "thin", color: { rgb: "000000" } },
                                right: { style: "thin", color: { rgb: "000000" } },
                            },
                            fill: r === 2 ? { patternType: "solid", fgColor: { rgb: "FFFF00" } } : undefined,
                        },
                    };
                }
            }

            // Configurar el rango de celdas
            worksheet["!ref"] = `A1:AE${data.length}`;

            // Combinar celdas para el título y encabezados
            worksheet["!merges"] = [
                { s: { r: 0, c: 0 }, e: { r: 0, c: 30 } }, // ANEXO
                { s: { r: 2, c: 0 }, e: { r: 2, c: 30 } }, // Título
                { s: { r: 4, c: 0 }, e: { r: 4, c: 30 } }, // Título 2
                { s: { r: 6, c: 1 }, e: { r: 6, c: 30 } }, // Título 2
                { s: { r: 7, c: 1 }, e: { r: 7, c: 30 } }, // Título 2
                { s: { r: 9, c: 2 }, e: { r: 9, c: 30 } }, // Cabecera "DÍAS"
                { s: { r: 26, c: 0 }, e: { r: 26, c: 1 } }, // FIRMA Y SELLO DEL PERSONAL
            ];
            // Definir anchos de columnas
            worksheet["!cols"] = [
            { wch: 20 },
                { wch: 25 }, // Columna B: RESPONSABLE
                ...Array(30).fill({ wch: 2 }), // Resto de columnas (DÍAS) con ancho 5
            ];
            /* const arrrayColor=[{cell:"A7",color:"ffca33 "},{cell:"A16",color:"ffca33 "},{cell:"B16",color:"ffca33 "},{cell:"A17",color:"ffca33 "},{cell:"A19",color:"ffca33 "},{cell:"B19",color:"ffca33 "},{cell:"A2O",color:"ffca33 "},{cell:"A24",color:"ffca33 "},{cell:"B24",color:"ffca33 "},{cell:"A25",color:"ffca33 "},{cell:"A28",color:"ffca33 "},{cell:"B28",color:"ffca33 "},{cell:"A29",color:"ffca33 "},{cell:"B29",color:"ffca33 "},{cell:"A30",color:"ffca33 "},{cell:"B30",color:"ffca33 "},{cell:"A31",color:"ffca33 "},{cell:"B31",color:"ffca33 "},{cell:"A32",color:"f7e002 "}];

            for (let i = 0; i < arrrayColor.length; i++) {
                const element = arrrayColor[i];
                console.log("Procesando celda:", element);

                // Limpiar el color
                const cleanColor = element.color.trim();

                // Verificar si la celda existe, si no, inicializarla
                if (!worksheet[element.cell]) {
                    console.log("elemento que no se encuentra",element.cell)
                    worksheet[element.cell] = {}; // Inicializa la celda
                }

                // Aplicar el estilo
                worksheet[element.cell].s = {
                    font: { bold: false, size: 9 },
                    alignment: { horizontal: "center", vertical: "center", wrapText: true },
                    fill: { patternType: "solid", fgColor: { rgb: cleanColor } },
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } },
                    },
                };
            } */
            // Agregar la hoja al libro
            XLSX.utils.book_append_sheet(workbook, worksheet, "Limpieza");

            // Generar y descargar el archivo Excel
            const excelData = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
            const buffer = new ArrayBuffer(excelData.length);
            const view = new Uint8Array(buffer);
            for (let i = 0; i < excelData.length; i++) view[i] = excelData.charCodeAt(i) & 0xff;
            const blob = new Blob([buffer], { type: "application/octet-stream" });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "ANEXO_CNSR-20D.xlsx";
            link.click();
        },
        exportToExcel5() {
            const XLSX = require("xlsx-js-style");
            // Crear una hoja de cálculo
            const workbook = XLSX.utils.book_new();
            const worksheet = {};

            // Definir el rango y las celdas
            const data = [
                ["ANEXO CNSR-21 A"],
                [],
                ["CONTROL DE CICLOS DE ESTERILIZACION A VAPOR"],
                [],
                ["IPRESS", "", "", "", "", "AUTOCLAVE", ""],
                ["CONTROL DE CICLOS DE ESTERILIZACIÓN A VAPOR ", "","","","", "FECHA:", ""],
                [],
                ["PROGRAMAS: (1) Gomas, Caucho, Latex, Jebes, Superficies", "", "", "", "", "ENFERMERA RESPONSABLE:", ""],
                ["(2) Textil (3) Instrumental (4) De vacio (5) B&D","","","","","",""],
                ["N° CICLO", "PROGRAMA", "OPERADOR DE CARGA", "HORA DE INICIO", "MATERIAL", "REGISTRO FISICO", ""],
                ["", "", "", "", "", "", ""],
                ["PARAMETROS", "", "OPERADOR DE CARGA", "HORA DE TERMINO", "", "", ""],
                ["TEMPERATURA: ", "", "" , "", "", "", ""],
                ["Presión (mmHG, Bar, KPS)", "", "", "", "", "" , ""],
                ["", "", "", "", "", "" , ""],
                ["Tiempo:", "", "", "", "", "", "" ],
                ["INDICADOR DEL PAQUETE", "", "", "", "", "", ""],
                ["OBSERVACIÓN", "", "", "", "", "", ""],
                
                ["IPRESS", "", "", "", "", "AUTOCLAVE", ""],
                ["CONTROL DE CICLOS DE ESTERILIZACIÓN A VAPOR ", "","","","", "FECHA:", ""],
                [],
                ["PROGRAMAS: (1) Gomas, Caucho, Latex, Jebes, Superficies", "", "", "", "", "ENFERMERA RESPONSABLE:", ""],
                ["(2) Textil (3) Instrumental (4) De vacio (5) B&D","","","","","",""],
                ["N° CICLO", "PROGRAMA", "OPERADOR DE CARGA", "HORA DE INICIO", "MATERIAL", "REGISTRO FISICO", ""],
                ["", "", "", "", "", "", ""],
                ["PARAMETROS", "", "OPERADOR DE CARGA", "HORA DE TERMINO", "", "", ""],
                ["TEMPERATURA: ", "", "" , "", "", "", ""],
                ["Presión (mmHG, Bar, KPS)", "", "", "", "", "" , ""],
                ["", "", "", "", "", "" , ""],
                ["Tiempo:", "", "", "", "", "", "" ],
                ["INDICADOR DEL PAQUETE", "", "", "", "", "", ""],
                ["OBSERVACIÓN", "", "", "", "", "", ""],

                ["IPRESS", "", "", "", "", "AUTOCLAVE", ""],
                ["CONTROL DE CICLOS DE ESTERILIZACIÓN A VAPOR ", "","","","", "FECHA:", ""],
                [],
                ["PROGRAMAS: (1) Gomas, Caucho, Latex, Jebes, Superficies", "", "", "", "", "ENFERMERA RESPONSABLE:", ""],
                ["(2) Textil (3) Instrumental (4) De vacio (5) B&D","","","","","",""],
                ["N° CICLO", "PROGRAMA", "OPERADOR DE CARGA", "HORA DE INICIO", "MATERIAL", "REGISTRO FISICO", ""],
                ["", "", "", "", "", "", ""],
                ["PARAMETROS", "", "OPERADOR DE CARGA", "HORA DE TERMINO", "", "", ""],
                ["TEMPERATURA: ", "", "" , "", "", "", ""],
                ["Presión (mmHG, Bar, KPS)", "", "", "", "", "" , ""],
                ["", "", "", "", "", "" , ""],
                ["Tiempo:", "", "", "", "", "", "" ],
                ["INDICADOR DEL PAQUETE", "", "", "", "", "", ""],
                ["OBSERVACIÓN", "", "", "", "", "", ""],
            ];

            // Rellenar la hoja de cálculo
            for (let r = 0; r < data.length; r++) {
                for (let c = 0; c < data[r].length; c++) {
                    const cell_ref = XLSX.utils.encode_cell({ r, c });
                    worksheet[cell_ref] = {
                        v: data[r][c],
                        s: {
                            font: { bold: r === 0 || r === 2, size: 9 },
                            alignment: { horizontal: "center", vertical: "center", wrapText: true, },
                            border: {
                                top: { style: "thin", color: { rgb: "000000" } },
                                bottom: { style: "thin", color: { rgb: "000000" } },
                                left: { style: "thin", color: { rgb: "000000" } },
                                right: { style: "thin", color: { rgb: "000000" } },
                            },
                            fill: r === 2 ? { patternType: "solid", fgColor: { rgb: "FFFF00" } } : undefined,
                        },
                    };
                }
            }

            // Configurar el rango de celdas
            worksheet["!ref"] = `A1:AE${data.length}`;

            // Combinar celdas para el título y encabezados
            worksheet["!merges"] = [
                { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }, // ANEXO
                { s: { r: 2, c: 0 }, e: { r: 2, c: 6 } }, // Título
                { s: { r: 4, c: 0 }, e: { r: 4, c: 4 } }, // IPRESS
                { s: { r: 5, c: 0 }, e: { r: 5, c: 4 } }, // TITULO
                { s: { r: 6, c: 0 }, e: { r: 6, c: 6 } }, // VACIO
                { s: { r: 7, c: 0 }, e: { r: 7, c: 4 } }, // PROGRAMAS 1
                { s: { r: 7, c: 5 }, e: { r: 7, c: 6 } }, // ENFERMERA RESPONSABLE
                { s: { r: 8, c: 0 }, e: { r: 8, c: 4 } }, // PROGRAMAS 2
                { s: { r: 8, c: 5 }, e: { r: 8, c: 6 } }, // RESPUESTA ENFERMERA RESPONSABLE
                { s: { r: 10, c: 5 }, e: { r: 15, c: 6 } }, // CUADRO EN BLANCO
                { s: { r: 9, c: 5 }, e: { r: 9, c: 6 } }, // REGISTRO FISICO
                { s: { r: 11, c: 0 }, e: { r: 11, c: 1 } }, // PARAMETROS
                { s: { r: 12, c: 2 }, e: { r: 15, c: 2 } }, // CUADRO EN BLANCO I
                { s: { r: 12, c: 3 }, e: { r: 15, c: 3 } }, // CUADRO EN BLANCO II
                { s: { r: 12, c: 0 }, e: { r: 12, c: 1 } }, // TEMPERATURA
                { s: { r: 13, c: 0 }, e: { r: 13, c: 1 } }, // PRESION
                { s: { r: 14, c: 0 }, e: { r: 14, c: 1 } }, // VACIO
                { s: { r: 15, c: 0 }, e: { r: 15, c: 1 } }, // TIEMPO
                { s: { r: 16, c: 0 }, e: { r: 16, c: 1 } }, // PAQUETE
                { s: { r: 16, c: 2 }, e: { r: 16, c: 6 } }, // PAQUETE
                { s: { r: 17, c: 0 }, e: { r: 17, c: 1 } }, // OBSERVACION
                { s: { r: 17, c: 2 }, e: { r: 17, c: 6 } }, // OBSERVACION

                { s: { r: 4+14, c: 0 }, e: { r: 4+14, c: 4 } }, // IPRESS
                { s: { r: 5+14, c: 0 }, e: { r: 5+14, c: 4 } }, // TITULO
                { s: { r: 6+14, c: 0 }, e: { r: 6+14, c: 6 } }, // VACIO
                { s: { r: 7+14, c: 0 }, e: { r: 7+14, c: 4 } }, // PROGRAMAS 1
                { s: { r: 7+14, c: 5 }, e: { r: 7+14, c: 6 } }, // ENFERMERA RESPONSABLE
                { s: { r: 8+14, c: 0 }, e: { r: 8+14, c: 4 } }, // PROGRAMAS 2
                { s: { r: 8+14, c: 5 }, e: { r: 8+14, c: 6 } }, // RESPUESTA ENFERMERA RESPONSABLE
                { s: { r: 10+14, c: 5 }, e: { r: 15+14, c: 6 } }, // CUADRO EN BLANCO
                { s: { r: 9+14, c: 5 }, e: { r: 9+14, c: 6 } }, // REGISTRO FISICO
                { s: { r: 11+14, c: 0 }, e: { r: 11+14, c: 1 } }, // PARAMETROS
                { s: { r: 12+14, c: 2 }, e: { r: 15+14, c: 2 } }, // CUADRO EN BLANCO I
                { s: { r: 12+14, c: 3 }, e: { r: 15+14, c: 3 } }, // CUADRO EN BLANCO II
                { s: { r: 12+14, c: 0 }, e: { r: 12+14, c: 1 } }, // TEMPERATURA
                { s: { r: 13+14, c: 0 }, e: { r: 13+14, c: 1 } }, // PRESION
                { s: { r: 14+14, c: 0 }, e: { r: 14+14, c: 1 } }, // VACIO
                { s: { r: 15+14, c: 0 }, e: { r: 15+14, c: 1 } }, // TIEMPO
                { s: { r: 16+14, c: 0 }, e: { r: 16+14, c: 1 } }, // PAQUETE
                { s: { r: 16+14, c: 2 }, e: { r: 16+14, c: 6 } }, // PAQUETE
                { s: { r: 17+14, c: 0 }, e: { r: 17+14, c: 1 } }, // OBSERVACION
                { s: { r: 17+14, c: 2 }, e: { r: 17+14, c: 6 } }, // OBSERVACION

                { s: { r: 4+28, c: 0 }, e: { r: 4+28, c: 4 } }, // IPRESS
                { s: { r: 5+28, c: 0 }, e: { r: 5+28, c: 4 } }, // TITULO
                { s: { r: 6+28, c: 0 }, e: { r: 6+28, c: 6 } }, // VACIO
                { s: { r: 7+28, c: 0 }, e: { r: 7+28, c: 4 } }, // PROGRAMAS 1
                { s: { r: 7+28, c: 5 }, e: { r: 7+28, c: 6 } }, // ENFERMERA RESPONSABLE
                { s: { r: 8+28, c: 0 }, e: { r: 8+28, c: 4 } }, // PROGRAMAS 2
                { s: { r: 8+28, c: 5 }, e: { r: 8+28, c: 6 } }, // RESPUESTA ENFERMERA RESPONSABLE
                { s: { r: 10+28, c: 5 }, e: { r: 15+28, c: 6 } }, // CUADRO EN BLANCO
                { s: { r: 9+28, c: 5 }, e: { r: 9+28, c: 6 } }, // REGISTRO FISICO
                { s: { r: 11+28, c: 0 }, e: { r: 11+28, c: 1 } }, // PARAMETROS
                { s: { r: 12+28, c: 2 }, e: { r: 15+28, c: 2 } }, // CUADRO EN BLANCO I
                { s: { r: 12+28, c: 3 }, e: { r: 15+28, c: 3 } }, // CUADRO EN BLANCO II
                { s: { r: 12+28, c: 0 }, e: { r: 12+28, c: 1 } }, // TEMPERATURA
                { s: { r: 13+28, c: 0 }, e: { r: 13+28, c: 1 } }, // PRESION
                { s: { r: 14+28, c: 0 }, e: { r: 14+28, c: 1 } }, // VACIO
                { s: { r: 15+28, c: 0 }, e: { r: 15+28, c: 1 } }, // TIEMPO
                { s: { r: 16+28, c: 0 }, e: { r: 16+28, c: 1 } }, // PAQUETE
                { s: { r: 16+28, c: 2 }, e: { r: 16+28, c: 6 } }, // PAQUETE
                { s: { r: 17+28, c: 0 }, e: { r: 17+28, c: 1 } }, // OBSERVACION
                { s: { r: 17+28, c: 2 }, e: { r: 17+28, c: 6 } }, // OBSERVACION
            ];

            // Definir anchos de columnas
            worksheet["!cols"] = [
                { wch: 10 }, // Columna A: TURNO
                { wch: 15 }, // Columna B: RESPONSABLE
                { wch: 10 },
                { wch: 10 },
                { wch: 10 },
                { wch: 15 },
                { wch: 15 },
            ];

            // Agregar la hoja al libro
            XLSX.utils.book_append_sheet(workbook, worksheet, "Limpieza");

            // Generar y descargar el archivo Excel
            const excelData = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
            const buffer = new ArrayBuffer(excelData.length);
            const view = new Uint8Array(buffer);
            for (let i = 0; i < excelData.length; i++) view[i] = excelData.charCodeAt(i) & 0xff;
            const blob = new Blob([buffer], { type: "application/octet-stream" });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "ANEXO_CNSR-21A.xlsx";
            link.click();
        },
        exportToExcel6() {
            const XLSX = require("xlsx-js-style");
            // Crear una hoja de cálculo
            const workbook = XLSX.utils.book_new();
            const worksheet = {};

            // Definir el rango y las celdas
            const data = [
                ["ANEXO CNSR- 21 B"],
                [],
                ["CONTROL DE TEST DE VACÍO Y BOWIE AND DICK"],
                [],
                ["IPRESS:", "", "", "", "", "AUTOCLAVE", ""],
                ["CONTROL DE TEST DE VACIO", "","","","", "FECHA:", ""],
                [],
                ["PROGRAMAS: (1) Gomas, Caucho, Latex, Jebes, Superficies", "", "", "", "", "ENFERMERA RESPONSABLE:", ""],
                ["(2) Textil (3) Instrumental (4) De vacio (5) B&D","","","","","",""],
                ["N° CICLO", "PROGRAMA", "OPERADOR DE CARGA", "HORA DE INICIO", "MATERIAL", "REGISTRO FISICO", ""],
                ["", "", "", "", "Test de Vacío", "", ""],
                ["PARAMETROS", "", "OPERADOR DE CARGA", "HORA DE TERMINO", "", "", ""],
                ["TEMPERATURA: ", "", "" , "", "", "", ""],
                ["Presión (mmHG, Bar, KPS)", "", "", "", "", "" , ""],
                ["", "", "", "", "", "" , ""],
                ["Tiempo:", "", "", "", "", "", "" ],
                ["INDICADOR DEL PAQUETE", "", "", "", "", "", ""],
                ["OBSERVACIÓN", "", "", "", "", "", ""],
                
                ["IPRESS", "", "", "", "", "AUTOCLAVE", ""],
                ["CONTROL DE TEST DE BOWIE AND DICK ", "","","","", "FECHA:", ""],
                [],
                ["PROGRAMAS: (1) Gomas, Caucho, Latex, Jebes, Superficies", "", "", "", "", "ENFERMERA RESPONSABLE:", ""],
                ["(2) Textil (3) Instrumental (4) De vacio (5) B&D","","","","","",""],
                ["N° CICLO", "PROGRAMA", "OPERADOR DE CARGA", "HORA DE INICIO", "MATERIAL", "REGISTRO FISICO", ""],
                ["", "", "", "", "Test de Bowie and Dick", "", ""],
                ["PARAMETROS", "", "OPERADOR DE CARGA", "HORA DE TERMINO", "", "", ""],
                ["TEMPERATURA: ", "", "" , "", "", "", ""],
                ["Presión (mmHG, Bar, KPS)", "", "", "", "", "" , ""],
                ["", "", "", "", "", "" , ""],
                ["Tiempo:", "", "", "", "", "", "" ],
                ["INDICADOR DEL PAQUETE", "", "", "", "", "", ""],
                ["OBSERVACIÓN", "", "", "", "", "", ""]
            ];

            // Rellenar la hoja de cálculo
            for (let r = 0; r < data.length; r++) {
                for (let c = 0; c < data[r].length; c++) {
                    const cell_ref = XLSX.utils.encode_cell({ r, c });
                    worksheet[cell_ref] = {
                        v: data[r][c],
                        s: {
                            font: { bold: r === 0 || r === 2, size: 9 },
                            alignment: { horizontal: "center", vertical: "center", wrapText: true, },
                            border: {
                                top: { style: "thin", color: { rgb: "000000" } },
                                bottom: { style: "thin", color: { rgb: "000000" } },
                                left: { style: "thin", color: { rgb: "000000" } },
                                right: { style: "thin", color: { rgb: "000000" } },
                            },
                            fill: r === 2 ? { patternType: "solid", fgColor: { rgb: "FFFF00" } } : undefined,
                        },
                    };
                }
            }

            // Configurar el rango de celdas
            worksheet["!ref"] = `A1:AE${data.length}`;

            // Combinar celdas para el título y encabezados
            worksheet["!merges"] = [
                { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }, // ANEXO
                { s: { r: 2, c: 0 }, e: { r: 2, c: 6 } }, // Título
                { s: { r: 4, c: 0 }, e: { r: 4, c: 4 } }, // IPRESS
                { s: { r: 5, c: 0 }, e: { r: 5, c: 4 } }, // TITULO
                { s: { r: 6, c: 0 }, e: { r: 6, c: 6 } }, // VACIO
                { s: { r: 7, c: 0 }, e: { r: 7, c: 4 } }, // PROGRAMAS 1
                { s: { r: 7, c: 5 }, e: { r: 7, c: 6 } }, // ENFERMERA RESPONSABLE
                { s: { r: 8, c: 0 }, e: { r: 8, c: 4 } }, // PROGRAMAS 2
                { s: { r: 8, c: 5 }, e: { r: 8, c: 6 } }, // RESPUESTA ENFERMERA RESPONSABLE
                { s: { r: 10, c: 5 }, e: { r: 15, c: 6 } }, // CUADRO EN BLANCO
                { s: { r: 9, c: 5 }, e: { r: 9, c: 6 } }, // REGISTRO FISICO
                { s: { r: 11, c: 0 }, e: { r: 11, c: 1 } }, // PARAMETROS
                { s: { r: 12, c: 2 }, e: { r: 15, c: 2 } }, // CUADRO EN BLANCO I
                { s: { r: 12, c: 3 }, e: { r: 15, c: 3 } }, // CUADRO EN BLANCO II
                { s: { r: 12, c: 0 }, e: { r: 12, c: 1 } }, // TEMPERATURA
                { s: { r: 13, c: 0 }, e: { r: 13, c: 1 } }, // PRESION
                { s: { r: 14, c: 0 }, e: { r: 14, c: 1 } }, // VACIO
                { s: { r: 15, c: 0 }, e: { r: 15, c: 1 } }, // TIEMPO
                { s: { r: 16, c: 0 }, e: { r: 16, c: 1 } }, // PAQUETE
                { s: { r: 16, c: 2 }, e: { r: 16, c: 6 } }, // PAQUETE
                { s: { r: 17, c: 0 }, e: { r: 17, c: 1 } }, // OBSERVACION
                { s: { r: 17, c: 2 }, e: { r: 17, c: 6 } }, // OBSERVACION

                { s: { r: 4+14, c: 0 }, e: { r: 4+14, c: 4 } }, // IPRESS
                { s: { r: 5+14, c: 0 }, e: { r: 5+14, c: 4 } }, // TITULO
                { s: { r: 6+14, c: 0 }, e: { r: 6+14, c: 6 } }, // VACIO
                { s: { r: 7+14, c: 0 }, e: { r: 7+14, c: 4 } }, // PROGRAMAS 1
                { s: { r: 7+14, c: 5 }, e: { r: 7+14, c: 6 } }, // ENFERMERA RESPONSABLE
                { s: { r: 8+14, c: 0 }, e: { r: 8+14, c: 4 } }, // PROGRAMAS 2
                { s: { r: 8+14, c: 5 }, e: { r: 8+14, c: 6 } }, // RESPUESTA ENFERMERA RESPONSABLE
                { s: { r: 10+14, c: 5 }, e: { r: 15+14, c: 6 } }, // CUADRO EN BLANCO
                { s: { r: 9+14, c: 5 }, e: { r: 9+14, c: 6 } }, // REGISTRO FISICO
                { s: { r: 11+14, c: 0 }, e: { r: 11+14, c: 1 } }, // PARAMETROS
                { s: { r: 12+14, c: 2 }, e: { r: 15+14, c: 2 } }, // CUADRO EN BLANCO I
                { s: { r: 12+14, c: 3 }, e: { r: 15+14, c: 3 } }, // CUADRO EN BLANCO II
                { s: { r: 12+14, c: 0 }, e: { r: 12+14, c: 1 } }, // TEMPERATURA
                { s: { r: 13+14, c: 0 }, e: { r: 13+14, c: 1 } }, // PRESION
                { s: { r: 14+14, c: 0 }, e: { r: 14+14, c: 1 } }, // VACIO
                { s: { r: 15+14, c: 0 }, e: { r: 15+14, c: 1 } }, // TIEMPO
                { s: { r: 16+14, c: 0 }, e: { r: 16+14, c: 1 } }, // PAQUETE
                { s: { r: 16+14, c: 2 }, e: { r: 16+14, c: 6 } }, // PAQUETE
                { s: { r: 17+14, c: 0 }, e: { r: 17+14, c: 1 } }, // OBSERVACION
                { s: { r: 17+14, c: 2 }, e: { r: 17+14, c: 6 } }, // OBSERVACION

                { s: { r: 4+28, c: 0 }, e: { r: 4+28, c: 4 } }, // IPRESS
                { s: { r: 5+28, c: 0 }, e: { r: 5+28, c: 4 } }, // TITULO
                { s: { r: 6+28, c: 0 }, e: { r: 6+28, c: 6 } }, // VACIO
                { s: { r: 7+28, c: 0 }, e: { r: 7+28, c: 4 } }, // PROGRAMAS 1
                { s: { r: 7+28, c: 5 }, e: { r: 7+28, c: 6 } }, // ENFERMERA RESPONSABLE
                { s: { r: 8+28, c: 0 }, e: { r: 8+28, c: 4 } }, // PROGRAMAS 2
                { s: { r: 8+28, c: 5 }, e: { r: 8+28, c: 6 } }, // RESPUESTA ENFERMERA RESPONSABLE
                { s: { r: 10+28, c: 5 }, e: { r: 15+28, c: 6 } }, // CUADRO EN BLANCO
                { s: { r: 9+28, c: 5 }, e: { r: 9+28, c: 6 } }, // REGISTRO FISICO
                { s: { r: 11+28, c: 0 }, e: { r: 11+28, c: 1 } }, // PARAMETROS
                { s: { r: 12+28, c: 2 }, e: { r: 15+28, c: 2 } }, // CUADRO EN BLANCO I
                { s: { r: 12+28, c: 3 }, e: { r: 15+28, c: 3 } }, // CUADRO EN BLANCO II
                { s: { r: 12+28, c: 0 }, e: { r: 12+28, c: 1 } }, // TEMPERATURA
                { s: { r: 13+28, c: 0 }, e: { r: 13+28, c: 1 } }, // PRESION
                { s: { r: 14+28, c: 0 }, e: { r: 14+28, c: 1 } }, // VACIO
                { s: { r: 15+28, c: 0 }, e: { r: 15+28, c: 1 } }, // TIEMPO
                { s: { r: 16+28, c: 0 }, e: { r: 16+28, c: 1 } }, // PAQUETE
                { s: { r: 16+28, c: 2 }, e: { r: 16+28, c: 6 } }, // PAQUETE
                { s: { r: 17+28, c: 0 }, e: { r: 17+28, c: 1 } }, // OBSERVACION
                { s: { r: 17+28, c: 2 }, e: { r: 17+28, c: 6 } }, // OBSERVACION
            ];

            // Definir anchos de columnas
            worksheet["!cols"] = [
                { wch: 10 }, // Columna A: TURNO
                { wch: 15 }, // Columna B: RESPONSABLE
                { wch: 10 },
                { wch: 10 },
                { wch: 10 },
                { wch: 15 },
                { wch: 15 },
            ];

            // Agregar la hoja al libro
            XLSX.utils.book_append_sheet(workbook, worksheet, "Limpieza");

            // Generar y descargar el archivo Excel
            const excelData = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
            const buffer = new ArrayBuffer(excelData.length);
            const view = new Uint8Array(buffer);
            for (let i = 0; i < excelData.length; i++) view[i] = excelData.charCodeAt(i) & 0xff;
            const blob = new Blob([buffer], { type: "application/octet-stream" });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "ANEXO_CNSR-21B.xlsx";
            link.click();
        },
        toggle() {
            if (this.selectedColumns.length === this.headers.length) {
                this.selectedColumns = [
                    "FECHA_RESULTADO", "SALA", "NUM_DOC", "AUTOGENERADO", "paciente"];
            } else {
                this.selectedColumns = this.headers.map(header => header.value);
            }
        },
        toggleColumn(value) {
            const index = this.selectedColumns.indexOf(value);
            if (index === -1) {
                this.selectedColumns.push(value);
            } else {
                this.selectedColumns.splice(index, 1);
            }
        },
        onInputChange(valor) {
            // Verifica si el array ya existe en `this.dataArray`
            const existe = this.dataArray.some(
                (arr) => JSON.stringify(arr.num_doc) === JSON.stringify(valor.num_doc)
            );

            // Si no existe, lo agrega
            if (!existe) {
                this.dataArray.push(valor);
            }
            console.log("valor de un item expuestossss ", valor);
            console.log("valor", this.dataArray);
        },
        save() {
            this.statusEdit = true;
            for (let i = 0; i < this.dataArray.length; i++) {
                const element = this.dataArray[i];
                axios
                    .post(RUTA_API + "/api/token/", {
                        username: USUARIO,
                        password: PASSWORD,
                    })
                    .then((response) => {
                        this.auth = "Bearer " + response.data.access;
                        axios
                            .post(RUTA_API + "/generar_actualizar/", { "id": element.id, "dosis_epo": element.dosis_epo, "via": element.via, "dosis_hierro": element.dosis_hierro, "observaciones": element.observaciones }, {
                                headers: { Authorization: this.auth },
                            })
                            .then((res) => {
                                this.isLoading = false;
                                this.dataInit();
                                this.dataArray = [];

                            })
                            .catch((res) => {
                                console.log("Error:", res);
                            });
                    })
                    .catch((response) => {
                        response === 404
                            ? console.warn("lo sientimos no tenemos servicios")
                            : console.warn("Error:", response);
                    });

            }
        },
        closeHistograma() {
            this.dialogHistograma = false;
        },
        saveDate() {
            // Ejecuta la lógica adicional
            this.loadPeriodo();
            // Luego ejecuta la función de guardado del diálogo
            this.$refs.dialog.save(this.date);
        },
        loadPeriodo() {
            let [year, month] = this.date.split('-');
            this.itemMes = month;
            this.itemPeriodo = year;
            /* this.dataInit(); */
        },
        exportExcel(item) {
            if(item==0){
                this.exportToExcel();
            }else if(item==1){
                this.exportToExcel2();
            }else if(item==2){
                this.exportToExcel3();
            }else if(item==3){
                this.exportToExcel4();
            }else if(item==4){
                this.exportToExcel5();
            }else if(item==5){
                this.exportToExcel6();
            }
        },
        closeDialog() {
            this.dialogImport = false;
            this.dataInit();
        },
        dataInit() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_reporte_laboratorio/", { periodo: this.itemPeriodo, mes: this.itemMes }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dialogLoader = false;
                            this.dataPaciente = res.data;

                        })
                        .catch((res) => {
                            this.dialogLoader = false;
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        formatearFecha(fecha) {
            // Dividir la fecha en partes: año, mes y día
            const partes = fecha.split("-");
            // Crear una nueva fecha con el formato "mm-dd-yyyy"
            const nuevaFecha = new Date(`${partes[1]}/${partes[2]}/${partes[0]}`);
            // Obtener el mes, día y año de la nueva fecha
            const mes = nuevaFecha.getMonth() + 1;
            const dia = nuevaFecha.getDate();
            const año = nuevaFecha.getFullYear();
            // Formatear la fecha en el formato deseado
            return `${mes.toString().padStart(2, "0")}-${dia
                .toString()
                .padStart(2, "0")}-${año}`;
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
    },
    mounted() { },
    computed: {
        filteredHeaders() {
            return this.headers.filter(header => this.selectedColumns.includes(header.value));
        },
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
        computedDateFormatted1() {
            return this.formatDate(this.date1);
        },
        icon() {
            if (this.likesAllFruit) return 'mdi-close-box'
            if (this.likesSomeFruit) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        likesAllFruit() {
            return this.headers.length === this.selectedColumns.length
        },
        likesSomeFruit() {
            return this.headers.length > 0 && !this.likesAllFruit
        },
        dataCasOptions() {
            // Formatear los elementos del objeto según lo requerido por v-select
            return this.dataCas.map((item) => ({
                text: item.descripCas,
                value: item.url,
            }));
        },
        itemClass() {
            return (item) => {
                if (item.cupos_disponible === 0) {
                    return "";
                } else {
                    return "bg-primary-table primary--text";
                }
            };
        },
        filteredData() {
            if (!this.searchAnexo) {
                return this.dataPaciente;
            }
            let filtered = this.dataPaciente;
            if (this.searchAnexo) {
                filtered = filtered.filter((item) => {
                    const nombreCompleto = item.anexo;
                    return nombreCompleto.toLowerCase().includes(this.searchAnexo.toLowerCase());
                });
            }
            return filtered;
        },
    },
    created() {
        this.loadPeriodo();
    },
    components: {
        /*  importPaciente,
         Histograma */
    },
};
</script>